module.exports = __webpack_public_path__ + "img/location.69bda3ec.svg";